import PageWrapper from "./pageWrapper";
export interface iInsecureRoute {
    title: string;
    children: React.ReactNode,
}
const InsecureRoute = ({ title, children }: iInsecureRoute) => {
    return <PageWrapper title={title}>{children}</PageWrapper>
}

export default InsecureRoute